import type {TargetLiterals} from '@github-ui/custom-properties-types'
import {Banner} from '@primer/react'

type Props = {
  propertyName: string
  count?: number
  targetLiterals: TargetLiterals
  errorMessage?: string
}

export function DefinitionInTargetsBanner({propertyName, count, targetLiterals, errorMessage}: Props) {
  const hasUsages = count && count > 0
  const variant = hasUsages || errorMessage ? 'warning' : 'info'
  const targetLiteral = count === 1 ? targetLiterals.single : targetLiterals.multiple

  const renderDescription = () => {
    if (errorMessage) {
      return <span>{errorMessage}</span>
    } else if (hasUsages) {
      return (
        <span>
          The <strong>{propertyName}</strong> property is referenced by{' '}
          <strong>
            {count} {targetLiteral}.
          </strong>
        </span>
      )
    }
    return (
      <span>
        No {targetLiterals.multiple} found that use the property: <strong>{propertyName}</strong>.
      </span>
    )
  }

  return (
    <Banner
      title="Definition usages in targets"
      hideTitle
      variant={variant}
      data-testid="target-usages-banner"
      description={renderDescription()}
    />
  )
}
